module.exports = __webpack_public_path__ + "img/barring.a8f99902.jpg";